import Super from 'client-portal/controllers/-request/message';
import classic from 'ember-classic-decorator';

@classic
export default class WidgetMessage extends Super {}
